export default "__VITE_ASSET__02SMtHyi__"